<template>
  <v-container fluid class="help">
    <v-row align="center">
      <v-col>
        <h1 class="text-center">[ ADMIN ] <br> Ideas Pod Booking</h1>
        <v-col class="text-center" v-if="isAdmin">
          
          <!-- calender and event dialog -->
          <v-row class="fill-height">
            <v-col>
              <v-sheet height="64">
                <v-toolbar
                  flat
                  extended
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="prev"
                  >
                    <v-icon small v-text="iconChevLeft">
                      mdi-chevron-left
                    </v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="next"
                  >
                    <v-icon small v-text="iconChevRight">
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                  <v-toolbar-title v-if="$refs.calendar">
                    {{ $refs.calendar.title }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>

                  <template v-slot:extension>
                    <v-spacer></v-spacer>
                    <v-btn
                    outlined
                    class="mr-4"
                    color="grey darken-2"
                    @click="setToday"
                  >
                    Today
                  </v-btn>

                  <v-menu
                    bottom
                    right
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        outlined
                        color="grey darken-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <span>{{ typeToLabel[type] }}</span>
                        <v-icon right v-text="iconMenuDown">
                          mdi-menu-down
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="type = 'day'">
                        <v-list-item-title>Day</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'week'">
                        <v-list-item-title>Week</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'month'">
                        <v-list-item-title>Month</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = '4day'">
                        <v-list-item-title>4 days</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-spacer></v-spacer>
                  </template>
                </v-toolbar>
              </v-sheet>
              <br><br>
              <v-sheet height="600">
                <v-calendar
                  ref="calendar"
                  v-model="focus"
                  color="primary"
                  first-interval="6"
                  interval-count="19"
                  :events="events"
                  :event-color="getEventColor"
                  :type="type"
                  @click:event="showEvent"
                  @click:more="viewDay"
                  @click:date="viewDay"
                  @change="updateRange"
                ></v-calendar>
                <v-menu
                  v-model="selectedOpen"
                  :close-on-content-click="false"
                  :activator="selectedElement"
                  offset-x
                >
                  <v-card
                    color="grey lighten-4"
                    min-width="350px"
                    flat
                  >
                    <v-toolbar
                      :color="selectedEvent.color"
                      dark
                    >
                      <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                      <span><b>No Tel: </b></span>
                      <span v-html="selectedEvent.no_tel"></span>
                      <br>
                      <span><b>Event Details: </b></span>
                      <span v-html="selectedEvent.details"></span>
                      <br>
                      <span><b>Room: </b></span>
                      <span v-html="this.getRoomName(selectedEvent.room)"></span>
                      <br>
                      <span><b>Pax: </b></span>
                      <span v-html="selectedEvent.pax"></span>
                      <br>
                      <span><b>Access Card: </b></span>
                      <span v-html="selectedEvent.adm_access_card"></span>
                      <br>
                      <span><b>Card Take: </b></span>
                      <span v-html="selectedEvent.adm_access_card_take_date"></span>
                      <br>
                      <span><b>Card Return: </b></span>
                      <span v-html="selectedEvent.adm_access_card_return_date"></span>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        v-if="isAdmin"
                        text
                        color="secondary"
                        @click="adminDialog = true"
                      >
                        Edit
                      </v-btn>
                      <v-btn
                        text
                        color="secondary"
                        @click="selectedOpen = false"
                      >
                        Cancel
                      </v-btn>
                      
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-sheet>
            </v-col>
          </v-row>

          <!-- admin dialog : to set access card -->
          <v-dialog
            v-model="adminDialog"
            max-width="500px"
            persistent
          >
            <v-card>
              <v-card-title>
                Admin Form 
              </v-card-title>
              <v-card-text>
                <span><b>ID: </b></span>
                <span v-html="selectedEvent.pushId"></span>
                <br>
                <span><b>CA Name: </b></span>
                <span v-html="selectedEvent.name"></span>
                <br>
                <span><b>No Tel: </b></span>
                <span v-html="selectedEvent.no_tel"></span>
                <br>
                <span><b>Event Details: </b></span>
                <span v-html="selectedEvent.details"></span>
                <br>
                <span><b>Pax: </b></span>
                <span v-html="selectedEvent.pax"></span>
                <br>
                <span><b>Room: </b></span>
                <span v-html="this.getRoomName(selectedEvent.room)"></span>
                <br>
                <span><b>Access Card: </b></span>
                <span v-html="selectedEvent.adm_access_card"></span>
                <br>
                <span><b>Card Take: </b></span>
                <span v-html="selectedEvent.adm_access_card_take_date"></span>
                <br>
                <span><b>Card Return: </b></span>
                <span v-html="selectedEvent.adm_access_card_return_date"></span>
                <br><br>
                <v-select
                  v-model="admCardSelect"
                  :items="admCardItems"
                  item-text="item"
                  item-value="value"
                  label="Access Card No"
                  outlined
                  dense
                  class="px-2"
                ></v-select>
                <v-text-field
                  v-model="dateTake"
                  label="Card Take Date"
                  outlined
                  dense
                  class="px-2"
                  placeholder="CTH : 12/07/2022"
                ></v-text-field>
                <v-text-field
                  v-model="dateReturn"
                  label="Card Take Return"
                  outlined
                  dense
                  class="px-2"
                  placeholder="CTH : 12/07/2022"
                ></v-text-field>
              </v-card-text>
              
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="adminDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="updateConfirmedBookingList(selectedEvent)"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>

            
          </v-dialog>

          <!-- progress status (edit) -->
          <v-snackbar
            v-model="snackbar"
            :timeout="snackbarTimeout"
            :multi-line="snackbarMultiLine"
            centered
          >
            {{ snackbarText }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="blue"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </template>
          </v-snackbar>

        </v-col>

        <!-- admin sign in dialog -->
        <v-col v-else class="text-center">
          <br><br><br>
          <v-form
            ref="form"
            @submit.prevent="signInAsAdmin"
          >
            <h3>Please enter admin's password to continue</h3>
            <p class="sub-heading-1">
              If you are CA, please use another link (no 4 from top)
            </p>
            <br>                    
            <v-text-field
              v-model="password"

              label="Password"
              outlined
              dense
              :append-icon="show3 ? mdiEye : mdiEyeOff"
              :type="show3 ? 'text' : 'password'"
              @click:append="show3 = !show3"
            ></v-text-field>

            <v-btn :disabled="!formIsValid" color="primary" type="submit" >Sign In</v-btn>
            <br>
          </v-form>

          <v-overlay :value="overlay">
          <v-card
              class="mx-auto pa-4"
              max-width="344"
              outlined
          > 
              <br>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              <h3 class="title ma-3">Signing In</h3>
              <br>
              
              <!--
              <v-btn
              icon
              @click="overlay = false"
              x-large
              
              >
              <v-icon>mdi-close</v-icon>
              Dismiss
              </v-btn>-->

          </v-card>
          </v-overlay>
          <v-overlay :value="overlayError">
          <v-card
              class="mx-auto pa-4"
              max-width="344"
              outlined
          > 
              <br>
              <h3 class="title ma-3">Password Error !</h3><p class="sub-title">Please enter correct password.</p>
              
              <v-btn
              icon
              @click="overlayError = false"
              x-large
              
              >
              <v-icon>{{mdiClose}}</v-icon>
              Dismiss
              </v-btn>
          </v-card>
          </v-overlay>
          <v-overlay :value="overlayInfoError">
          <v-card
              class="mx-auto pa-4"
              max-width="344"
              outlined
          > 
              <br>
              <h3 class="title ma-3">Invalid Input.</h3><p class="sub-title">Please fill up the form.</p>
              
              <v-btn
              icon
              @click="overlayInfoError = false"
              x-large
              
              >
              <v-icon>{{mdiClose}}</v-icon>
              Dismiss
              </v-btn>
          </v-card>
          </v-overlay>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiChevronLeft, mdiChevronRight, mdiMenuDown, mdiClose, mdiEye, mdiEyeOff } from '@mdi/js'
import { getDatabase, ref, onValue, push, update } from "firebase/database";
import { dbPaths } from "../assets/dbPaths.js";

export default {
  data: () => ({
    
    mdiClose,
    mdiEye,
    mdiEyeOff,
    overlay: false,
    overlayError: false,
    overlayInfoError: false,
    password: '',
    show3: false,
    storedAgentCode: '',
    
    isAdmin: false,
    adminDialog: false,
    admCardSelect: '',
    admCardItems: [
      { item: '1', value: '1' }, 
      { item: '2', value: '2' }, 
      { item: '3', value: '3' }, 
      { item: '4', value: '4' },
    ],
    dateTake:'',
    dateReturn: '',

    iconChevLeft: mdiChevronLeft,
    iconChevRight: mdiChevronRight,
    iconMenuDown: mdiMenuDown,
    focus: '',
    type: 'week',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],

    rules: {
      text: [val => (val || '').length > 0 || 'This field is required'],
      date: [val => (val !== (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10) || 'Pick a proper date')]
    },

    snackbar: false,
    snackbarText: '',
    snackbarTimeout: 5000,
    snackbarMultiLine: false,

    
       
  }),

  computed: {
    //for sign in as admin dialog.
    formIsValid() {
      return this.password 
    },
    
    //for edit access card no.
    adminDialogIsValid() {
      return this.admCardSelect
    }    
  },

  mounted () {
    if (window.sessionStorage.getItem('isAdmin') == 'true') {
      this.isAdmin = true
    } else {
      this.isAdmin = false
    }

    if(window.sessionStorage.getItem('agentCode')) {
      this.storedAgentCode = window.sessionStorage.getItem('agentCode').toUpperCase()
    } else {
      console.log('agentCode ERROR');
    }

    //this.getBookingDateRange()

    //this.$refs.calendar.checkChange()
  },

  methods: {
    //imported functions/ template functions. (calender)
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'

      //console.log('focus + ' + this.focus);
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        //console.log('event push id: ' + event.pushId);
        this.admCardSelect = event.adm_access_card
        this.dateTake = event.adm_access_card_take_date
        this.dateReturn = event.adm_access_card_return_date
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    //update calendar.
    updateRange () {
      //read data from db.............
      const events = []
      const db = getDatabase();
      //tuka mse prod.
      //const dbRef = ref(db, 'test/records/ipod_booking/2022');
      const dbRef = ref(db, dbPaths.toIPodBooking() + new Date().getFullYear());

      onValue(dbRef, (snapshot) => {

        snapshot.forEach((childSnapshot) => {
          events.push(childSnapshot.val())
        });

      }, {
        onlyOnce: true
      });

      this.events = events
    },

    //to get room info based on room no.
    getRoomName(roomNo) {
      switch (roomNo) {
        case "1" :
          return 'IPod 1';
        case "2" :
          return 'IPod 2';
        case "3" :
          return 'IPod Hall';
        case "4" :
          return 'IPod Pingpong';
      
        default:
          return 'error';
      }
    },

    //new functions.
    signInAsAdmin() {
      this.overlay = true
      if (this.password === 'adminTSA') {

        const db = getDatabase();
        const date = new Date();

        push(ref(db, dbPaths.toAdminSignIn() + date.getFullYear() + '/' + date.getMonth() ), {
            agent_code: window.sessionStorage.getItem('agentCode').toUpperCase(),
            date: date.toDateString(), 
            time: date.toLocaleTimeString(),
        })
        .then(() => {
            // Data saved successfully!
            
            window.sessionStorage.setItem('isAdmin', true)
            this.isAdmin = true
            this.overlay = false
        })
        .catch((error) => {
            // The write failed...
            console.log(error);
            this.isAdmin = false
            this.overlay = false
        });

      } else {
          this.overlay = false
          this.overlayError = true
      }
    },

    /**editBooking(passedData) {
      //console.log(passedData.pushId);
      
      const db = getDatabase();
      const bookRef = ref(db, 'test/records/ipod_booking/2022/' + passedData.pushId);
      
      update(bookRef, {

        adm_access_card: this.admCardSelect,
        adm_is_approved: true,
        adm_approval_date: new Date().toDateString(),

      })
      .then(() => {
          // Data saved successfully!
          this.updateRange()
          this.adminDialog = false
          
      })
      .catch((error) => {
          // The write failed...
          console.log(error);
      });

    },**/

    //new functions : to update upon confirming booking, giving access card.
    updateConfirmedBookingList(passedEventData) {
      
      console.log("(update data) take: " + this.dateTake + ' || return: ' + this.dateReturn);

      //if(!this.dateTake) {this.dateTake = ''}
      //if(!this.dateReturn) {this.dateReturn = ''}
      
      const db = getDatabase();
      //const bookRef = ref(db, 'test/records/ipod_booking/2022/' + passedEventData.pushId);

      const data = {
        ...passedEventData,
        adm_access_card: this.admCardSelect,
        adm_is_approved: true,
        adm_approval_date: new Date().toDateString(),
        adm_access_card_take_date: this.dateTake,
        adm_access_card_return_date: this.dateReturn,
      }

      const updates = {}
      updates[dbPaths.toIPodBooking() + new Date().getFullYear()+ '/' + passedEventData.pushId] = data
      updates[dbPaths.toIPodBookingConfirmed() + new Date().getFullYear() + '/' + passedEventData.pushId] = data
      //updates['test/records/ipod_booking/2022/' + passedEventData.pushId] = data
      //updates['test/records/ipod_booking_confirmed/2022/' + passedEventData.pushId] = data

      update(ref(db), updates)
      .then(() => {
        this.updateRange()
        this.adminDialog = false
        this.snackbarMultiLine = false
        this.snackbar = true
        this.snackbarText = 'Succcess.'
      })
      .catch((error) => {
        console.log(error.message);
        this.updateRange()
        this.adminDialog = false
        this.snackbarMultiLine = true
        this.snackbar = true
        this.snackbarText = 'ERROR ==> ' + error.message
      })

    }

  },

  
}
</script>